import React from "react";

const Footer = () => (
  <footer className="bg-light p-3 text-center">
    <div className="logo" />
    <p className="mb-2">
      BillsMax Copyright 2026.
    </p>
    <p className="mb-0">
      <a href="https://www.billsmax.com/privacy">Privacy Policy</a>
    </p>
  </footer>
);

export default Footer;
